(function () {
  'use strict';

  // Switches a cart line between one-time delivery and a SealSubscriptions selling plan,
  // from the subscribe button (one-time lines) or the plan dropdown (subscription lines).
  // The cart re-renders through the theme's cart:updated -> cart:build flow afterwards.
  if (window.nhCartSellingPlanBound) return;
  window.nhCartSellingPlanBound = true;

  function changeUrl() {
    var route = window.theme && window.theme.routes && window.theme.routes.cartChange;
    return (route || '/cart/change.js') + '?t=' + Date.now();
  }

  function setOpen(dropdown, open) {
    var toggle = dropdown.querySelector('[data-nh-selling-plan-toggle]');
    var list = dropdown.querySelector('.nh-cart-selling-plan__list');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    list.hidden = !open;
    dropdown.classList.toggle('is-open', open);
  }

  function closeAll(except) {
    document.querySelectorAll('[data-nh-selling-plan].is-open').forEach(function (dropdown) {
      if (dropdown !== except) setOpen(dropdown, false);
    });
  }

  function changePlan(dropdown, value) {
    var key = dropdown.getAttribute('data-key');
    var quantity = parseInt(dropdown.getAttribute('data-quantity'), 10) || 1;
    if (!key) return;

    dropdown.classList.add('is-loading');
    dropdown.querySelectorAll('button').forEach(function (button) {
      button.disabled = true;
    });

    fetch(changeUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        // null removes the selling plan, which means one-time delivery.
        selling_plan: value ? parseInt(value, 10) : null,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (cart.status === 422 || !cart.items) {
          window.alert(cart.description || cart.message);
          document.dispatchEvent(new Event('cart:build'));
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart },
        }));
      })
      .catch(function (error) {
        console.error('Selling plan could not be changed.', error);
        document.dispatchEvent(new Event('cart:build'));
      });
  }

  document.addEventListener('click', function (event) {
    var dropdown = event.target.closest('[data-nh-selling-plan]');
    closeAll(dropdown);
    if (!dropdown) return;

    // One-time line: the "Jetzt im Abo sparen" button subscribes to the first plan right away.
    var subscribe = event.target.closest('[data-nh-selling-plan-subscribe]');
    if (subscribe) {
      changePlan(dropdown, subscribe.getAttribute('data-value'));
      return;
    }

    if (event.target.closest('[data-nh-selling-plan-toggle]')) {
      setOpen(dropdown, !dropdown.classList.contains('is-open'));
      return;
    }

    var option = event.target.closest('[data-nh-selling-plan-option]');
    if (!option) return;

    setOpen(dropdown, false);
    if (option.getAttribute('aria-current') === 'true') return;
    changePlan(dropdown, option.getAttribute('data-value'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var dropdown = document.querySelector('[data-nh-selling-plan].is-open');
    if (!dropdown) return;

    setOpen(dropdown, false);
    dropdown.querySelector('[data-nh-selling-plan-toggle]').focus();
  });
})();
